import React from 'react'
import { clients } from '../../data/data'
import './testimonials.css'

import { Pagination, Autoplay } from 'swiper'

import { Swiper, SwiperSlide } from 'swiper/react'

// Import Swiper styles
import 'swiper/css'
import 'swiper/css/pagination'

function Testimonials() {
  return (
    <section id='testimonials'>
      <h5>Review from clients</h5>
      <h2>Testimonials</h2>
      <Swiper
        modules={[Pagination, Autoplay]}
        autoplay={{
          delay: 1000,
          pauseOnMouseEnter: true,
          waitForTransition: true,
        }}
        spaceBetween={40}
        slidesPerView={1}
        pagination={{ clickable: true }}
        className='container testimonials__container'
      >
        {clients.map(({ name, img, review }, i) => (
          <SwiperSlide key={i} className='testimonial'>
            <div className='client__avatar'>
              <img src={img} alt='' />
            </div>
            <h5 className='client__name'>{name}</h5>
            <small className='client__review'>{review}</small>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  )
}

export default Testimonials
